import { mount } from 'svelte';
// Inter and JetBrains Mono ship inside the bundle, as in Navitech ID: the
// console makes no request to a font CDN. Mono carries every figure, so it
// needs the bold weights the stat tiles (700) and the logo glyph (800) use.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/jetbrains-mono/700.css';
import '@fontsource/jetbrains-mono/800.css';
import './app.css';
import App from './App.svelte';

const app = mount(App, {
	target: document.getElementById('app')!,
});

export default app;
